export default __webpack_public_path__ + "static/media/homam.9df283cb.png";